
import BaseView from "@core/View.js";
export default class ServiceListView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        
        this._parentEl = this._model._parent._view._serverBoxEl;
        // console.log('服务数据',this._model);
    }
    getInitData() {
      if(this._model._parent._data.services && this._model._parent._data.services.length>0) {
        
          // 处理数据
          this._model._parent._data.services.forEach((item,index)=>{

              this._model._serviceList.map((i,d)=> {

                i.serviceGoodsList.map((ind,data)=>{
                  if(item.id == ind.code) {
                    i.cateChecked = true;
                    i.selectServiceItem = ind;
                  }
                })
              })
          })
      } else {
        this._model._serviceList.map((i,d)=> {
            i.cateChecked = false;
        })
    }
    // console.log('处理数据之后的',this._model._serviceList);
  }
  serviceGoodsLists(item){
    let html = ''
      item.serviceGoodsList.map((items, indexs) => {
        html+= `<li code="${items?.code}" tag='onClickSerItemLi'>
        <span class='spanitem'>${items?.name}</span><span>¥${items?.price?.P_C?.C_1?.P_0?.DV?.V}</span>
      </li>`
    })
    return html
  }
  serviceGoodsLista(item){
    let hts = ''
    item.serviceGoodsList.map((items, indexs) => {
      hts += `<li code="${items.code}" tag='onClickSerItemLi'>
        ${items.name}<span>¥${items.price.P_C.C_1.P_0.DV.V}</span>
      </li>`
    })
    return hts

  }
  getItemPList(item){
    // console.log('pc的服务数据',item);

    if(item.cateChecked){
      return `<li class="service_item selected" >
        <p  tag="onClickChSerList" class="selected" code=${item.selectServiceItem?.code}  placeholder="${item?.category}">
          <i class="fr iconfont icon-arrow-down"></i>
          <i class="fr iconfont icon-arrow-up"></i>
          <span>${item.selectServiceItem?.name}¥${item.selectServiceItem?.price?.P_C?.C_1?.P_0?.DV?.V}</span>
        </p>
        <ol>
        ${
          this.serviceGoodsLists(item)
        }
        </ol>
      </li>`
    }else{
      return `<li class="service_item">
        <p  tag="onClickChSerList" code=${item.categorycode}  placeholder="${item.category}">
          <i class="fr iconfont icon-arrow-down"></i>
          <i class="fr iconfont icon-arrow-up"></i>
          <span>${item.category}</span>
        </p>
      <ol>
      ${
        this.serviceGoodsLista(item)
         
      }
      </ol>
    </li>`
    }
    
  }
    getItems(){
        let html = ''
        this._model._serviceList.map((item,index) => {
            html += `
          
            ${this.getItemPList(item)}`
        })
      return html
    }
    render(){
      this.getInitData();
      let tmpId = this._model._parent._id + '_' + this._model._parent._parent._id;  
        let html = "";
        html += `
        <ul class="clearfix" tag='mainsku_serviceBox' skuid=${tmpId}>
            ${this.getItems()}
        </ul>
        <div class="service_btn_group" tag="service_btn_group">
            <button class="le_btn le_btn_solid confirm" tag='onServiceOK'>确定</button>
            <button class="le_btn le_btn_border cancel" tag='onServiceCancel' >取消</button>
        </div>`;
        $(this._parentEl).html($(html));
        this._el = $("ul[tag='mainsku_serviceBox']");
        this._els = $("div[tag='service_btn_group']");
        this._ela = $("div[skuid='" + tmpId + "']");
        this._elddd = $("ul[skuid='" + tmpId + "']");
        this._top = $("div#cart_pc_wrapper");
        this.regEvent();
    }
    regEvent(){
        let that = this;
        // $("#cart_pc_wrapper").click(function(){
        //   that._model._view._parentEl.hide()
        //   var iconfontDom = that._ela.find("[tag=onClickChSerivce] i.iconfont")
        //   if(iconfontDom.hasClass('icon-arrow-down')){
        //       iconfontDom.removeClass('icon-arrow-down').addClass('icon-arrow-up')
        //   }else{
        //       iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down')
        //   }
        // });
        this._el.off("click","p[tag='onClickChSerList']").on("click","p[tag='onClickChSerList']",function(){
            // $(this).parent().find('ol').show();
            if($(this).parent().find('ol').css('display') == 'block') {
              if($(this).siblings('ol').children('li').hasClass("active")){
                $(this).parent("li.service_item").addClass("selected");
              } else {
                $(this).parent().removeClass('active');
              }
              
              var placehoder = $(this).siblings('ol').children('li.active').text() ? $(this).siblings('ol').children('li.active').text() : $(this).attr('placeholder');
              $(this).find('span').text(placehoder);

              $(this).parent().find('ol').hide();
            } else if ($(this).parent().find('ol').css('display') == 'none') {
              $(this).parent().find('ol').show();
              var placehoder = $(this).attr('placeholder');
              // console.log('placeholder',placehoder)
              var code = $(this).attr("code");
              var olis = $(this).closest('li.service_item').find('ol>li');
              $(this).closest("li").addClass("active");
              if($(this).closest("li").hasClass("active")){
                $(this).find('span').text(placehoder)
                $(this).parents("li.service_item").removeClass("selected")
              }
              for(var i=0;i<olis.length;i++){
                $(olis[i]).removeClass("active")
                if($(olis[i]).attr('code') == code){
                  $(olis[i]).addClass("active")
                }
              }
            }
            
        })
        this._el.off("click","[tag='onClickSerItemLi']").on("click","[tag='onClickSerItemLi']",function(){
            $(this).parent().hide()
            var value = $(this).text();
            var placehoder = $(this).parents("li.service_item").find("p[tag='onClickChSerList']").attr('placeholder');
            let status = $(this).parents("li.service_item")
            // console.log(status)
            if($(this).hasClass("active")){
              $(this).parents("li.service_item").find("p>span").text(placehoder)
              $(this).parents("li.service_item").find("p").attr('code','')
              $(this).parents("li.service_item").removeClass("selected")
              $(this).parents("li.service_item").removeClass("active")
              $(this).parents("li.service_item").find("p").removeClass("selected")
            }else{
              $(this).parents("li.service_item").find("p>span").text(value)
              $(this).parents("li.service_item").find("p").attr('code',$(this).attr('code'))
              $(this).parents("li.service_item").removeClass("active").addClass("selected")
              $(this).parents("li.service_item").find("p").addClass("selected")
            }
      
        })
        // 选择服务取消
        this._els.off("click","[tag='onServiceCancel']").on("click","[tag='onServiceCancel']",function(){
          that._model._view._parentEl.hide();
          var _li =  that._model._parent._view._el.find('li.service_wrapper');
          var iconfontDom =  _li.find('[tag=onClickChSerivce] i.iconfont');
          _li.removeClass("active");
          iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down');
             
        })
        this._els.off("click", "[tag='onServiceOK']").on("click", "[tag='onServiceOK']", function () {
         
          var selectedItem =  that._elddd.find($("p[tag='onClickChSerList'].selected"));
          var codes ="";
          selectedItem.each(function(index,li){
              codes += $(li).attr('code')+"@";
            }); 
          codes = codes.substr(0,codes.length-1);
          that._model._parent.modifyItemFromCart({opsType:3,content:codes}).then(()=>{
            if(selectedItem.length == 0) {
              $(that._model._parent._view._extraBoxEl.find('div.service')).hide();
              $(that._model._parent._view._el.find('li.service_wrapper button span')).html('选择服务');
            } else if(selectedItem.length > 0) {
              $(that._model._parent._view._el.find('li.service_wrapper button span')).html('修改服务');
            }
          });
          that._model._view._parentEl.hide()
          var _li =  that._model._parent._view._el.find('li.service_wrapper');
          var iconfontDom =  _li.find('[tag=onClickChSerivce] i.iconfont');
          _li.removeClass("active");
          iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down');
         
      })
  
        
    }
    
}

